import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.scrollToBottom()
    this.#observe()
  }

  disconnect() {
    this.observer?.disconnect()
  }

  scrollToBottom() {
    // defer so Turbo stream mutations are applied first
    requestAnimationFrame(() => {
      this.element.scrollTop = this.element.scrollHeight
    })
  }

  #observe() {
    this.observer = new MutationObserver(() => this.scrollToBottom())
    this.observer.observe(this.element, {
      childList: true,
      subtree: true,
    })
  }
}
